export class ShowAlert {
    public static readonly type = '[Root state] Show alert';

    constructor(public payload: string) { }
}
